import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Gamepad2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        await exchangeSession(sessionId);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [location, exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-16 h-16 rounded-sm bg-[#06B6D4]/20 border border-[#06B6D4]/50 flex items-center justify-center mx-auto mb-4 animate-pulse">
          <Gamepad2 className="w-8 h-8 text-[#06B6D4]" />
        </div>
        <p className="text-zinc-400 font-mono text-sm">Authenticating...</p>
      </div>
    </div>
  );
}
